export default __webpack_public_path__ + "static/media/office-building-redflag.4755af3b.svg";